'use strict';

angular.module('youth').controller('QuoteCtrl', ['quote', function (quote) {
  this.quote = quote;
}]);